import { Text, Heading, Box } from '@simplywallst/ui-core';
import { Container, Logo, Content, SectionLogo, SectionText } from './styled';
import { useTranslation, Translation } from '@/hooks/useTranslation';
import { useFlag } from '@/features/unleash';
import { DarkSplashPanelRegister } from './DarkSplashPanelRegister';
import { LightSplashPanelRegister } from './LightSplashPanelRegister';

export const SplashPanelRegister = () => {
  const t = useTranslation();
  const { flagsReady, variant } = useFlag({ name: 'mono-signup-wall' });

  if (!flagsReady) return;

  if (variant.name === 'variant-dark') {
    return <DarkSplashPanelRegister />;
  }

  if (variant.name === 'variant-light') {
    return <LightSplashPanelRegister />;
  }

  return (
    <Container>
      <Content>
        <SectionLogo>
          <Logo />
        </SectionLogo>
        <SectionText>
          <Box marginTop="x3" marginBottom="x0_75">
            <Heading as="h1" typography="xSmallStrong" color="charcoal">
              <Translation i18nKey="app.modal.registration.splash.tagLine">
                The revolution for <br />
                <Text as={'span'} color={'brand01'}>
                  long-term investors
                </Text>
              </Translation>
            </Heading>
          </Box>
          <Text color={'darkerGray'}>
            {t('app.modal.registration.splash.promotionalText')}
          </Text>
        </SectionText>
      </Content>
    </Container>
  );
};
